import { Controller } from "@hotwired/stimulus";
import { reloadWithTurbo } from "../turboHelper";
import { postRequestAndWaitForJobCompletion } from "../jobCompletion";
import { translate } from "../translate";
import * as TranslationsKeys from "../locale/translationsKeys";
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "../dialogConstants";

export default class DetailOldController extends Controller {

    static values = {
        generateTtsUrl: String,
        getJobUrl: String,
        isExternalUser: Boolean
    }

    readonly generateTtsUrlValue!: string;
    readonly getJobUrlValue!: string;
    readonly isExternalUserValue!: boolean;

    generateTts(event) {
        const actionButton = $(event.currentTarget);
        const generateTtsUrl = this.generateTtsUrlValue;
        const getJobUrl = this.getJobUrlValue;
        const isExternalUser = this.isExternalUserValue;

        bootbox.confirm({
            message: translate(TranslationsKeys.Global_Generate_Audio_Confirmation_Message) +
                     "<br><br>" +
                     (isExternalUser
                        ? translate(TranslationsKeys.Global_Generate_Audio_Confirmation_Message_Suffix_For_External_User)
                        : ""),
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                postRequestAndWaitForJobCompletion(
                    generateTtsUrl,
                    undefined,
                    getJobUrl,
                    actionButton,
                    () => {
                        reloadWithTurbo();
                    }
                );
            }
        });
    }
}
